/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
import React, {useEffect, useState} from 'react'
import {PageTitle} from 'layout/master-layout'
// import {toast} from 'react-toastify'
import {ITab, KTTab} from 'helpers/ui-components/KTTab'
import Spinner from 'layout/common/Spinner'
import {useAuth} from 'context/AuthProvider'
import {ILedgerEntries} from 'models/Ledger'
import {
 downloadStatement,
 fetchLedgerEntries,
} from 'utils/api/ledgerService'
import FileDownload from 'js-file-download'
import {useTranslation} from 'react-i18next'
import {ColumnProps, IFormField} from 'models/Common'
import {
 convertEpochToDate,
 convertToDateEpoch,
 formatDateForDB,
 formatDateForDisplay,
 formatNumberForDisplay,
 generateRandomNo,
} from 'utils/helper'
import {KTFilterBox} from 'helpers/ui-components/KTFilterBox'
import {fetchFilterConfig} from 'utils/api/auth/commonService'
import KTTable from 'helpers/ui-components/KTTable'
import {Button, Model} from 'helpers'
import {downloadFileFromUrl} from 'utils/api/httpService'
import {createFilterPayload} from 'utils/helpers/genericFilterForm'
import {KTSummaryCard} from 'helpers/ui-components/KTSummaryCard'

type IProps = {
 hidePartent: boolean
 setHideParent: (newState: boolean) => void
}

const cardColor = [
 '#FFF3C2',
 '#E3D7F5',
 '#FDC',
 '#E3F5CE',
 '#CED8E0',
]

const LedgerManagementPage = (props: IProps) => {
 const {t} = useTranslation()
 //  const navigate = useNavigate()
 const {userData} = useAuth()
 const accessDetails =
  userData?.userSubModule?.ledger?.homePage
 const [loader, setLoader] = useState(false)
 const [showDownloadPopup, setShowDownloadPopup] =
  useState(false)
 const [downloadFileFormat, setDownloadFileFormat] =
  useState('')
 const [filterCount, setFilterCount] = useState(0)
 const [currentPage, setCurrentPage] = useState(1)
 const [totalRecords, setTotalRecords] = useState(0)
 const [itemsPerPage, setItemsPerPage] = useState(25)
 const [tableColList, setTableColList] = useState<
  Array<ColumnProps<ILedgerEntries>>
 >([])
 const [aggregatorId, setAggregatorId] = useState<
  number | null
 >(null)
 const [filterFormData, setFilterFormData] =
  useState<IFormField | null>(null)
 const [filterFormatedData, setFilterFormatedData] =
  useState<IFormField>()
 const [filterConfig, setFilterConfig] = useState<
  IFormField[]
 >([])
 const [ledgerEntries, setLedgerEntries] = useState<
  ILedgerEntries[]
 >([])
 const [ledgerCards, setLedgerCards] = useState<ITab[]>([])
 const tabList: ITab[] = [
  {
   title: t('ledger.distributor'),
   id: 'distributor',
   icon: '',
  },
 ]

 const [activeTab, setActiveTab] = useState('distributor')
 const categoryList = [
  {
   key: '',
   value: 'All',
  },
  {
   key: 'invoice',
   value: 'Invoice',
  },
  {
   key: 'payment',
   value: 'Payment',
  },
 ]

 const cardList = [
  {
   title: t('ledger.totalInvoiceAmount'),
   id: 'total_invoice_amount',
   icon: '',
   count: 0,
  },
  {
   title: t('ledger.totalPaymentReceived'),
   id: 'total_payment_amount',
   icon: '',
   count: 0,
  },
 ]

 const getFilterConfig = async () => {
  setLoader(true)
  const res = await fetchFilterConfig({
   filter_type: 'LEDGER_LISTING',
  })
  if (res) {
   setFilterConfig(res?.applicableFilters ?? [])
  }
  setLoader(false)
 }

 const getLedgerEntries = async (
  pageNo: number,
  activeTab: string
 ) => {
  setLoader(true)
  const payload = await createFilterPayload(
   filterConfig,
   filterFormData
  )
  setFilterCount(payload.totalAppliedFilters)
  delete payload.totalAppliedFilters
  const res = await fetchLedgerEntries({
   page: pageNo,
   page_size: itemsPerPage,
   ...filterFormData,
   ...payload,
  })
  if (res) {
   cardList.map((val) => {
    val.count = res[val.id as keyof typeof res] as number
   })
   setLedgerCards(cardList)
   setLedgerEntries(res.results)
   setTotalRecords(res?.count ?? 0)
  }
  setLoader(false)
 }

 const downloadLedgerStatement = async () => {
  setLoader(true)
  const payload = await createFilterPayload(
   filterConfig,
   filterFormData
  )
  setFilterCount(payload.totalAppliedFilters)
  delete payload.totalAppliedFilters
  const res = await downloadStatement({
   download_format: downloadFileFormat,
   page: currentPage,
   ...filterFormData,
   ...payload,
  })
  if (res) {
   const now = new Date()
   const timestamp = now
    .toISOString()
    .slice(0, 19)
    .replace(/[-:]/g, '')
    .replace('T', '_')
   const filename = `Aggregator-Distributor_Statement_${timestamp}.${downloadFileFormat}`
   await downloadFileFromUrl(res, filename)
   setShowDownloadPopup(false)
  }
  setLoader(false)
 }

 const handleTabClick = async (index: string) => {
  if (activeTab !== index) {
   setActiveTab(index)
   setCurrentPage(1)
   await getLedgerEntries(1, index)
  }
 }

 const handlePageChange = async (pageNo: number) => {
  setCurrentPage(pageNo)
  await getLedgerEntries(pageNo, activeTab)
 }

 useEffect(() => {
  if (currentPage !== 1) {
   setCurrentPage(1)
  }
  void getLedgerEntries(1, activeTab)
 }, [itemsPerPage])

 const handleShowDownloadPopup = () => {
  setDownloadFileFormat('')
  setShowDownloadPopup(true)
 }

 const applyCategoryFilter = async (
  aggregatorType: string
 ) => {
  setFilterFormData((prevState: IFormField) => ({
   ...prevState,
   transaction_type: aggregatorType,
  }))
 }

 const ledgerTableConfig = async () => {
  setLoader(true)

  const columns: Array<ColumnProps<ILedgerEntries>> = [
   {
    key: 'transaction_id',
    title: t('ledger.tableCol.transactionId'),
   },
   {
    key: 'transaction_type',
    title: t('ledger.tableCol.transactionType'),
   },
   {
    key: 'transaction_date',
    title: t('ledger.tableCol.date'),
    className: 'w-[120px] ',
    render: (_, record) => {
     return formatDateForDisplay(
      convertEpochToDate(record?.transaction_date),
      'DD-MMM-YYYY'
     )
    },
   },
   ...(userData?.userCategoryKey === 'input_super_admin'
    ? [
       {
        key: 'partner_name',
        title: t('ledger.tableCol.from'),
       },
      ]
    : []),
   {
    key: 'counterparty_name',
    title: t('ledger.tableCol.to'),
   },
   {
    key: 'credit_amount',
    title: (
     <span style={{whiteSpace: 'nowrap'}}>
      {t('ledger.tableCol.creditAmonut')} (
      <i
       className='fa fa-inr px-0.5'
       aria-hidden='true'
      ></i>
      )
     </span>
    ),
    className: 'w-[120px] ',
    render: (_, record) => {
     return formatNumberForDisplay(record?.credit_amount)
    },
   },
   {
    key: 'debit_amount',
    title: (
     <span style={{whiteSpace: 'nowrap'}}>
      {t('ledger.tableCol.debitAmount') + ' '}(
      <i className='fa fa-inr px-0.5'></i>)
     </span>
    ),
    className: 'w-[120px] ',
    render: (_, record) => {
     return formatNumberForDisplay(record?.debit_amount)
    },
   },
  ]
  setTableColList(columns)
  setLoader(false)
 }

 useEffect(() => {
  void getFilterConfig()
 }, [])

 useEffect(() => {
  if (filterFormData && filterConfig.length > 0) {
   if (currentPage !== 1) {
    setCurrentPage(1)
   }
   void getLedgerEntries(1, activeTab)
  }
 }, [filterFormData, filterConfig])

 useEffect(() => {
  void ledgerTableConfig()
 }, [ledgerEntries])

 return (
  <>
   {loader && <Spinner />}
   <Model
    show={showDownloadPopup}
    showHeader={false}
    closeBtnClass='absolute right-4 top-2 !bg-[#E6EBF0] !rounded-3xl w-7 h-7 !text-[#33393D]'
    header={''}
    close={() => {
     setShowDownloadPopup(false)
    }}
    modelClass='md:w-[600px]'
    modelContainerClass='!rounded-2xl'
    modelBodyClass='p-10'
   >
    <div className='w-full'>
     <div className='w-full'>
      <p className='text-[#171B1F] text-left font-bold text-2xl'>
       {t('ledger.downloadStatement')}
      </p>
      <p className='text-[#33393D] text-left font-medium text-xl mt-7'>
       {t('ledger.selectFormat')}
      </p>
      <div
       className={`${
        downloadFileFormat === 'xlsx' &&
        '!border-[#4E83E4] bg-[#E9F0FE] border-2'
       } border border-[#E6EBF0] rounded-lg p-4 flex items-center 
      hover:border-[#4E83E4] hover:bg-[#E9F0FE] hover:border-2 my-7 cursor-pointer`}
       onClick={() => {
        setDownloadFileFormat('xlsx')
       }}
      >
       <i
        className='fa fa-file-excel-o text-[50px] text-[#30835A] pr-4'
        aria-hidden='true'
       ></i>
       <div className='text-[#33393D] font-medium text-lg'>
        {t('ledger.aggregatorXlsxFile')}
       </div>
      </div>
      <div
       className={`${
        downloadFileFormat === 'pdf' &&
        '!border-[#4E83E4] bg-[#E9F0FE] border-2'
       } border border-[#E6EBF0] rounded-lg p-4 flex items-center 
      hover:border-[#4E83E4] hover:bg-[#E9F0FE] hover:border-2 cursor-pointer`}
       onClick={() => {
        setDownloadFileFormat('pdf')
       }}
      >
       <i
        className='fa fa-file-pdf-o text-[50px] text-[#1C88ED] pr-4'
        aria-hidden='true'
       ></i>
       <div className='text-[#33393D] font-medium text-lg'>
        {t('ledger.aggregatorPdfFile')}
       </div>
      </div>

      <div className='md:flex items-center justify-center my-7'>
       <Button
        disabled={!downloadFileFormat}
        type='button'
        color='blue'
        onClick={downloadLedgerStatement}
        className='text-center w-full py-[9px] px-[24px] bg-[#4E83E4] 
                        !rounded-lg !text-base text-white font-semibold'
       >
        {t('common.next')}
       </Button>
      </div>
     </div>
    </div>
   </Model>
   <div
    className={`${
     props.hidePartent ? 'hidden' : 'visible'
    } w-full min-h-full`}
   >
    <KTFilterBox
     parentId={'LEDGER_HISTORY'}
     btnText={t('helperText.filter')}
     dateRangeContainerClass='mx-6'
     dateRangeTitle={t('common.dateRange')}
     showDateRangeBox={true}
     filterConfig={filterConfig}
     setLoader={setLoader}
     filterFormData={filterFormData}
     filterCount={filterCount}
     setFilterFormData={setFilterFormData}
    >
     <div className='flex items-center'>
      <div
       className={`text-[#33393D] font-medium text-sm mr-2`}
      >
       {t('common.quickFilters')}
      </div>
      {categoryList.map((val, key) => (
       <div
        key={key}
        onClick={() => {
         void applyCategoryFilter(val.key)
        }}
        className={` ${
         (filterFormData?.transaction_type
          ? filterFormData?.transaction_type === val.key
          : val.key === '') &&
         '!bg-[#4E83E4] text-white border-[#4E83E4]'
        } text-center py-1.5 px-3 bg-white 
                 rounded-lg text-sm text-[#33393D] bg-white border font-medium border-[#CED8E0]
                 hover:bg-[#4E83E4] hover:text-white cursor-pointer mr-2 w-[90px]`}
       >
        {val.value}
       </div>
      ))}
     </div>

     {accessDetails?.section?.downloadStatement
      ?.canView && (
      <Button
       type='button'
       disabled={false}
       onClick={handleShowDownloadPopup}
       color='blue'
       className='ml-auto w-[200px] text-center py-2 px-4 bg-white 
              !rounded-lg text-sm text-[#4E83E4] hover:bg-[#4E83E4] hover:!text-white font-semibold border-[#4E83E4]'
      >
       <i
        className='fa fa-download pr-2'
        aria-hidden='true'
       ></i>
       {t('ledger.downloadStatement')}
      </Button>
     )}
    </KTFilterBox>
    <div className='grid md:grid-cols-4 items-center gap-4 my-6 pb-6 border-[#E6EBF0] border-b'>
     {ledgerCards.map((val, key) => (
      <KTSummaryCard
       key={key}
       title={val.title}
       count={
        <span>
         &#8377;{' '}
         {val?.count
          ? formatNumberForDisplay(val?.count)
          : 0}
        </span>
       }
       color={
        cardColor[key] ?? generateRandomNo(cardColor.length)
       }
      />
     ))}
    </div>
    <KTTab
     activeTabId={activeTab}
     containerClass='my-6 '
     tabHeaderContainerClass='mb-6 !justify-center'
     tabHeaderClass='px-2 items-end'
     activeClass='text-[#4E83E4] font-semibold border-b-[3px] border-[#4E83E4] '
     onClick={handleTabClick}
     tabs={tabList}
     tabContent={
      <div className='w-full'>
       <p className='text-[#2F2F2F] text-lg font-medium mb-6 '>
        {t('ledger.listOfTransaction')}
       </p>
       <KTTable
        data={ledgerEntries}
        columns={tableColList}
        headerClass='bg-[#80868C]'
        headerColClass='!border-0 text-left'
        colClass='text-[#33393D] !text-sm font-normal !border-0 !py-3'
        tableClass=''
        rowClass='even:bg-[#E6EBF0]'
        showPagination={true}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
        totalRecord={totalRecords}
        onPageChange={handlePageChange}
       />
      </div>
     }
    />
   </div>
  </>
 )
}

export default function LedgerManagementPageWrapper() {
 // for using different languages and changing the text in to other languages
 // const intl = useIntl()
 const [hidePartent, setHideParent] = useState(false)
 const {t} = useTranslation()
 return (
  <div className='container relative'>
   <div className='px-[72px] pt-6 pb-[200px] bg-white'>
    {!hidePartent && (
     <PageTitle
      breadcrumbContainerClass={
       'flex text-[#5A6066] text-sm font-normal items-center pb-6 border-[#E6EBF0] border-b'
      }
      breadcrumbs={[
       {
        title: t('breadCrumbs.home'),
        path: '/home-page',
        isActive: false,
       },
       {
        title: t('breadCrumbs.ledger'),
        path: '',
        isActive: true,
       },
      ]}
      description='Welcome'
     >
      {t('breadCrumbs.ledger')}
     </PageTitle>
    )}
    <LedgerManagementPage
     hidePartent={hidePartent}
     setHideParent={setHideParent}
    />
   </div>
  </div>
 )
}
